/* INTEGY V776 basic filter controls. One URL change per user action; no client-side
   reordering that might misrepresent results beyond the current pagination. */
(function(){
'use strict';
var COLORS=['black','blue','red','green','silver','orange','purple','gold','gunmetal','grey','gray','white','yellow'];
var IDX=['all','all-integy-hop-up-parts','hopups-for-traxxas','hop-up-parts-for-traxxas','parts-for-traxxas','on-sale-clearance-up-to-80'];
function isCollection(root){return root.dataset.integyV776Kind==='collection';}
function url(){return new URL(location.href);}
function base(root){return new URL(root.dataset.integyV776Base,location.origin).pathname.replace(/\/$/,'');}
function selectedColorFromPath(root){
 var b=base(root),path=decodeURIComponent(location.pathname),rest=path.startsWith(b+'/')?path.slice(b.length+1):'';
 return rest.split('+').map(function(s){return s.toLowerCase();}).find(function(s){return COLORS.includes(s);})||'';
}
function selectedColorFromQuery(u){
 var q=u.searchParams.get('q')||'';
 var match=q.match(/^tag:(black|blue|red|green|silver|orange|purple|gold|gunmetal|grey|gray|white|yellow)\s+AND\s+/i);
 return match?match[1].toLowerCase():'';
}
function stockMode(root,u){
 var a=u.searchParams.get('filter.v.availability'),s=u.searchParams.get('integy_stock');
 if(s==='all'||s==='in'||s==='out')return s;
 if(a==='0')return'out';
 if(a==='1')return'in';
 return 'all';
}
function update(){
 document.querySelectorAll('[data-integy-v776-refine]').forEach(function(root){
  var u=url(),mode=stockMode(root,u);
  root.querySelectorAll('[data-integy-v776-stock]').forEach(function(el){el.setAttribute('aria-pressed',el.dataset.integyV776Stock===mode?'true':'false');});
  var sort=root.querySelector('[data-integy-v776-sort]'),chosen=u.searchParams.get('sort_by')||'';
  if(sort){sort.value=Array.prototype.some.call(sort.options,function(opt){return opt.value===chosen;})?chosen:'';}
  var color=root.querySelector('[data-integy-v776-color]');
  if(color){var c=isCollection(root)?selectedColorFromPath(root):selectedColorFromQuery(u);
    color.value=Array.prototype.some.call(color.options,function(opt){return opt.value===c;})?c:'';
    if(color.options.length<=1){color.disabled=true;color.title='No tagged colors available for these results';color.setAttribute('aria-label','Color: not available for these results');}
  }
 });
}
function v787Owns(u){
 var p=u.pathname,q=u.searchParams.get('q')||'';
 return p==='/collections/all-integy-hop-up-parts' ||
        p.indexOf('/collections/all-integy-hop-up-parts/')===0 ||
        ((p==='/collections/vendors'||p==='/collections/vendors/') &&
         (q.toLowerCase()==='integy'||q.toLowerCase().indexOf('integy/')===0));
}
function navigate(root,kind,value){
 var u=url(),p=u.searchParams,isCol=isCollection(root);
 // V787 owns stock/color/reset for the Integy vendor/master collection.
 // Preserve V776 sort, which V787 deliberately does not intercept.
 if(v787Owns(u)&&kind!=='sort')return;
 p.delete('page');p.delete('section_id');
 if(kind==='stock'){
  p.delete('filter.v.availability');p.delete('integy_stock');
  if(isCol){
   var handle=base(root).split('/')[2]||'';
   if(IDX.includes(handle)){
    p.set('integy_stock',value);
   }else if(value==='all'){
    p.set('integy_stock','all');
   }else{
    p.set('filter.v.availability',value==='out'?'0':'1');
   }
  }else{
   /* Shopify search's default excludes unavailable products, so an out-of-stock
      facet without this option misleadingly returns zero results. Keep the
      original search query and its other options unchanged. */
   p.set('type','product');
   p.set('options[unavailable_products]','show');
   if(value==='all')p.set('integy_stock','all');
   else p.set('filter.v.availability',value==='out'?'0':'1');
  }
 }else if(kind==='sort'){
  if(value)p.set('sort_by',value);else p.delete('sort_by');
 }else if(kind==='color'){
  if(isCol){
   var b=base(root),current=decodeURIComponent(location.pathname);
   var tags=current.startsWith(b+'/')?current.slice(b.length+1).split('+').filter(Boolean):[];
   tags=tags.filter(function(t){return !COLORS.includes(t.toLowerCase());});
   if(value)tags.push(value);
   u.pathname=b+(tags.length?'/'+tags.map(encodeURIComponent).join('+'):'');
  }else{
   var q=p.get('q')||'';
   q=q.replace(/^tag:(?:black|blue|red|green|silver|orange|purple|gold|gunmetal|grey|gray|white|yellow)\s+AND\s+/i,'');
   if(value)q='tag:'+value+' AND '+q;
   p.set('q',q);
   p.set('type','product');p.set('options[prefix]','last');p.set('options[unavailable_products]','show');
  }
 }else if(kind==='reset'){
  p.delete('sort_by');p.delete('filter.v.availability');p.delete('integy_stock');
  if(isCol){
   u.pathname=base(root);
   ['integy_filter','integy_filters','integy_tag_filter','integy_vehicle_filter'].forEach(function(x){p.delete(x);});
   var resetHandle=base(root).split('/')[2]||'';
   if(IDX.includes(resetHandle)||resetHandle==='on-sale-clearance-up-to-80'||resetHandle==='all')p.set('integy_stock','in');
   else p.set('filter.v.availability','1');
  }else{
   var q=p.get('q')||'';
   /* All stock states must include unavailable products in the source set. */
   p.set('type','product');
   p.set('options[unavailable_products]','show');
   p.set('q',q.replace(/^tag:(?:black|blue|red|green|silver|orange|purple|gold|gunmetal|grey|gray|white|yellow)\s+AND\s+/i,''));
   p.set('integy_stock','all');
  }
 }
 if(u.href!==location.href)location.assign(u.href);
}
document.addEventListener('click',function(e){
 var btn=e.target.closest('[data-integy-v776-stock],[data-integy-v776-reset]');if(!btn)return;
 var root=btn.closest('[data-integy-v776-refine]');if(!root)return;
 e.preventDefault();navigate(root,btn.hasAttribute('data-integy-v776-reset')?'reset':'stock',btn.dataset.integyV776Stock||'');
});
document.addEventListener('change',function(e){
 var el=e.target;if(!el.matches('[data-integy-v776-sort],[data-integy-v776-color]'))return;
 var root=el.closest('[data-integy-v776-refine]');if(!root)return;
 navigate(root,el.hasAttribute('data-integy-v776-sort')?'sort':'color',el.value);
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',update,{once:true});else update();
})();